export const versaoAtualSisaf = {
  interfaceDAF: 'v.1.9.1',
  interfaceSES: 'v.0.1.0',
  interfaceFornecedor: 'v.0.2.0',
};
